import HomeTemplate from '../templates/HomeTemplate.jsx'
import { SITE_NAME, SITE_URL } from '../utils/seo.js'

const title = `Convert Video to MP3 Without Software – ${SITE_NAME}`
const description = 'Convert video to MP3 without downloading or installing any software. FastAudio runs entirely in your browser — just paste a URL and download your MP3 instantly.'
const canonical = `${SITE_URL}/convert-without-software`

export default function ConvertWithoutSoftware() {
  return (
    <HomeTemplate
      provider="generic"
      title={title}
      description={description}
      canonical={canonical}
      badge="No Installation Needed"
      heading={
        <>
          Convert Without{' '}
          <span className="text-gradient">Any Software</span>
        </>
      }
      subheading="No downloads, no installations. FastAudio converts video to MP3 directly in your browser — on any device, any operating system, for free."
    />
  )
}
